Vue.component("header-component", {
    data: function () {
        return {
            scrolled: false,
            menuExpanded: false
        }
    },
    mounted: function () {
        let that = this;
        window.addEventListener('scroll', function () {
            that.watchScrollPosition();
        });

        this.watchScrollPosition();
    },
    methods: {
        watchScrollPosition: function () {
            let that = this;
            const scrollTop = Math.max(window.scrollY, window.pageYOffset);

            if (scrollTop > 50) {
                that.scrolled = true;
            } else {
                that.scrolled = false;
            }
        },
        toggleMenu: function () {
            this.menuExpanded = !this.menuExpanded;

            if (this.menuExpanded) {
                disableBodyScroll(targetElement);
            }
            else {
                enableBodyScroll(targetElement);
            }
        }
    },
});